import api from '@/modules/planning/api';
import { mapQualificationIdsToObjects } from '../../../components/utils/utils';

const state = {
	error: null,
	dutyTemplates: [],
};

const getters = {};

const mutations = {
	setError(state, { error }) {
		state.error = error;
	},

	setDutyTemplates(state, dutyTemplates) {
		state.dutyTemplates = dutyTemplates;
	},
	updateDutyTemplate(state, { updatedTemplate, getQualificationById }) {
		const formattedQualifications = mapQualificationIdsToObjects(updatedTemplate.qualifications, getQualificationById);
		const updatedDutyTemplate = {
			...updatedTemplate,
			qualifications: formattedQualifications,
			labels: updatedTemplate.labels,
		};

		const index = state.dutyTemplates.findIndex((t) => t._id === updatedTemplate._id);
		if (index !== -1) {
			state.dutyTemplates.splice(index, 1, updatedDutyTemplate);
		}
	},
	updateDutyTemplateFromSocket(state, { updatedDuty, getQualificationById }) {
		const formattedQualifications = mapQualificationIdsToObjects(updatedDuty.qualifications, getQualificationById);
		const index = state.dutyTemplates.findIndex((t) => t._id === updatedDuty.id);
		if (index !== -1) {
			const existingTemplate = state.dutyTemplates[index];
			const mergedTemplate = {
				...existingTemplate,
				...updatedDuty,
				qualifications: formattedQualifications,
				labels: updatedDuty.labels,
			};

			state.dutyTemplates[index] = mergedTemplate;
		}
	},
};

const actions = {
	async load({ commit }, { deleted, excludeProvider }) {
		try {
			let dutyTemplates = await api.dutyTemplateList({ deleted, excludeProvider });

			if (dutyTemplates) {
				dutyTemplates = dutyTemplates.data;
				commit('setDutyTemplates', dutyTemplates);
			}
		} catch (err) {
			commit('setError', { error: err.response?.data.message });
		}
	},

	async restore({ commit, dispatch }, { id, index }) {
		try {
			await api.restoreDuty(id);
			dispatch('load', { deleted: true });
		} catch (err) {
			commit('setError', { error: err.response?.data.message });
		}
	},
	async delete({ commit, dispatch }, { id, index }) {
		try {
			await api.deleteDuty({ dutyId: id });

			dispatch('load', { deleted: true });
		} catch (err) {
			commit('setError', { error: err.response?.data.message });
		}
	},

	updateDutyTemplate({ commit, rootGetters }, updatedTemplate) {
		const getQualificationById = rootGetters['qualification/getQualificationById'];
		commit('updateDutyTemplate', { updatedTemplate, getQualificationById });
	},

	async socket_updated_Duty({ commit, rootGetters }, payload) {
		const getQualificationById = rootGetters['qualification/getQualificationById'];
		const updatedDuty = payload[0].payload;
		commit('updateDutyTemplateFromSocket', { updatedDuty, getQualificationById });
	},

	clearError({ commit }) {
		commit('setError', { error: null });
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
